import { Typography } from "antd";

const { Text } = Typography;
export const INITIAL_OBJECT = {
    fleetCount: '',
    flightHours: '',
    flightCycle: '',
    laborRate: '',
    aircraftLifTime: '',
    errorFieds: {
        fleetCount: '',
        flightHours: '',
        flightCycle: '',
        laborRate: '',
        aircraftLifTime: '',
    }
}

export const EMPLOYEE_COLUMNS_HEAD = () => {
    return [
        {
            title: 'Serial No.',
            dataIndex: 'serial_no',
            align: 'left',
        },
        {
            title: 'Employee Name',
            dataIndex: '',
            align: 'left',
            render: (ele) => {
                return <Text style={{ wordBreak: 'break-word' }}>{ele.first_name} {ele.last_name}</Text>
            }
        },
    ]
};

export const ADD_EMPLOYEE_INITIAL_OBJECT = {
    name: '',
    errorFieds: {
        name: '',
    }
}